<template lang="html">
  <fullscreen-overlay-layout
    @close="$emit('close')"
    :title="getCurrentRT.title"
  >
    <div
      style="padding: 20px;"
      :class="{ 'hidden-record': submission.is_hidden }"
    >
      <submission-card-header
        :showHeaderOptions="false"
        :submission="submission"
      />

      <submission-response-text
        :submission="submission"
        :shortenText="true"
        :smallFont="true"
      />
      <div class="start-xs">
        <span class="i" style="font-size: 12px; color: #273248;">
          {{ getPromptWordsLength }} Words
        </span>
      </div>
      <div class="ml-auto mt3 tc relative">
        <assessment-tab :submission="submission" />
      </div>
    </div>
  </fullscreen-overlay-layout>
</template>
<script>
  import { mapGetters } from 'vuex';
  import SubmissionCardHeader from './submissionCard/cardHeader';
  import SubmissionResponseText from './submissionResponseText';
  import AssessmentTab from './assessmentTab.vue';
  import FullscreenOverlayLayout from 'components/fullscreenOverlay';
  import wordCountService from '../services/wordCount/wordCount';

  export default {
    data() {
      return {
        show_all_comments: false,
      };
    },
    components: {
      SubmissionCardHeader,
      SubmissionResponseText,
      AssessmentTab,
      FullscreenOverlayLayout,
    },
    computed: {
      ...mapGetters(['getOrderedSubmissions', 'getCurrentRT']),
      topLevelCommentID() {
        return this.$route.query.topLevelCommentID;
      },
      submissionID() {
        return this.$route.query.submissionID;
      },
      submission() {
        const foundSubmission = this.getOrderedSubmissions.find(
          (submission) => submission.id === this.submissionID
        );
        return foundSubmission || { id: null };
      },
      getPromptWordsLength() {
        return wordCountService.getWordCount(this.submission);
      },
      commentsToShow() {
        return this.submission.comments || [];
      },
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
</style>



// WEBPACK FOOTER //
// individualAssessmentOverlay.vue?70f59381